import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ImageZoom from '../../common/image-zoom'
import { Avatar } from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import React, { forwardRef, useState } from 'react'
import { UserAction as ApiCall } from '../../redux/action'
import {
    formatExactTimestamp,
    formatRelativeNotificationTime
} from "../../utils/CommonFunction";
import { ROUTER_NAME } from '../../router/routers'
import { formatMessageBody } from '../../utils/formatMessageBody'

const NotificationCard = ({ notification, setLastElement, index }) => {
    const navigate = useNavigate()
    const { data: notes } = useSelector(state => state.notesList_vendor)
    const dispatch = useDispatch()

    const [isProcessing, setIsProcessing] = useState(false);

    const handleMarkAsRead = (id) => {
        setIsProcessing(true);
        dispatch(ApiCall.markAsRead(id)).finally(() => setIsProcessing(false));
    };

    const isUnread = !notification?.is_read;

    return (
        <div
            className={`card ${isUnread ? 'card-unread' : ''}`}
            ref={setLastElement}
            data-card-index={index}
        >

            <div className="avatar-wrapper">
                {/* Unread Dot floating on top left corner of avatar */}
                <span
                    className={`notification-status ${isUnread ? 'notification-bubble-yellow' : 'notification-bubble-white'}`}
                />

                <ImageZoom
                    imageSrc={notification?.profile?.profile_image}
                    altSrc={notification?.profile?.profile_image}
                >
                    <Avatar
                        src={notification?.profile?.profile_image}
                        sx={{
                            height: 'calc(var(--fs-xl)*1.88679) !important',
                            width: 'calc(var(--fs-xl)*1.88679) !important',
                            fontSize: 'calc(var(--fs-xs)*1.88679) !important',
                            borderRadius: 'var(--sp-xs) !important',
                            border: isUnread ? '1.5px solid #FBB516' : '1px solid #e5e7eb',
                        }}
                    />
                </ImageZoom>
            </div>

            <div
                className="notification-body"
                onClick={() => {
                    if (!notification.is_read && !isProcessing) {
                        handleMarkAsRead(notification.id);
                    }
                    if (notification.vendor_notes) {
                        notification?.thread_id && navigate(`${ROUTER_NAME.notesDetail}/${notification?.thread_id}`, { state: { scroll: true, note: notification } });
                    } else {
                        notification.order_id && navigate(`${ROUTER_NAME.orderDetail}/${notification.order_id}`, { state: { scroll: true } });
                    }
                }}
            >
                <span className={`notification-title ${isUnread ? 'notification-title-unread' : ''}`}>
                    {formatMessageBody(notification.content)}
                </span>
                <span className="notification-time" title={formatExactTimestamp(notification?.created)}>
                    <AccessTimeIcon sx={{
                        fontSize: 'calc(var(--fs-xs)*1.3)',
                        color: '#9CA3AF',
                        transform: 'translateY(-1px)',
                    }} />
                    {formatRelativeNotificationTime(notification.created)}
                </span>
            </div>
        </div>
    );
}

export default forwardRef(NotificationCard)